import { Bars } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
export default function Loader() {
    const loading = useSelector((state: any) => state.appReducer.loading);
    return (loading ? <div className='backdrop'   >
        <Bars color='#000000' />
    </div> : null)

}